const MAXIMUM_TIMER_SECONDS = 99 * 60 + 59;

export const timeDiffText = (diffInSeconds: number) => {
  const minutes = Math.floor(diffInSeconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days} DAY${days === 1 ? "" : "S"}`;
  }

  if (hours > 0) {
    return `${hours} HOUR${hours === 1 ? "" : "S"}`;
  }

  if (minutes > 0) {
    return `${minutes} MINUTE${minutes === 1 ? "" : "S"}`;
  }

  return `${diffInSeconds} SECOND${diffInSeconds === 1 ? "" : "S"}`;
};

export const formatDuration = (durationInMinutes: number): string =>
  timeDiffText(durationInMinutes * 60).toLowerCase();

export const formatTimerSeconds = (timerSeconds: number): string => {
  let remainingSeconds = timerSeconds;

  if (timerSeconds < 0) {
    console.warn(`Timer seconds cannot be negative`);
    remainingSeconds = 0;
  }

  if (timerSeconds > MAXIMUM_TIMER_SECONDS) {
    console.warn(
      `Timer seconds cannot be greater than ${MAXIMUM_TIMER_SECONDS}`,
    );
    remainingSeconds = MAXIMUM_TIMER_SECONDS;
  }

  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

export const formatDurationSeconds = (durationInSeconds: number) => {
  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor((durationInSeconds % 3600) / 60);
  const seconds = Math.floor(durationInSeconds % 60);

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const formatStreamTime = (seconds: number, shorten = false): string => {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (days > 0) {
    return `${days} ${shorten ? "d" : `day${days === 1 ? "" : "s"}`}`;
  } else if (hours > 0) {
    return `${hours} ${shorten ? "h" : `hour${hours === 1 ? "" : "s"}`} ${minutes} ${shorten ? "m" : `minute${minutes === 1 ? "" : "s"}`}`;
  } else if (minutes > 0) {
    return `${minutes} ${shorten ? "m" : `minute${minutes === 1 ? "" : "s"}`} ${remainingSeconds} ${shorten ? "s" : `second${remainingSeconds === 1 ? "" : "s"}`}`;
  } else {
    return `${remainingSeconds} ${shorten ? "s" : `second${remainingSeconds === 1 ? "" : "s"}`}`;
  }
};
